(function ($) {
  $(document).on("change", "#acf-field_64d4f016fccd5", function () {
    selectVal = $(this).find("option:selected").val();
    console.log($(this).find("option:selected").val());
    if (selectVal == "group") {
      $(".acf-field-64d4f04bfccd7").show();
    } else {
      $(".acf-field-64d4f04bfccd7").hide();
    }
  });

  $(document).on("gform_post_render", function (event, form_id, current_page) {
    if (form_id == 2) {
      if ($("#field_2_16 #input_2_16").val()) {
        $("#field_2_16").addClass("gfield_visibility_hidden");
        $("#field_2_16").hide();
      }

      if ($("#field_2_17 #input_2_17").val()) {
        $("#field_2_17").addClass("gfield_visibility_hidden");
        $("#field_2_17").hide();
      }

      if ($("#field_2_18 #input_2_18").val()) {
        $("#field_2_18").addClass("gfield_visibility_hidden");
        $("#field_2_18").hide();
      }
    }
  });
})(jQuery);
